import { render, staticRenderFns } from "./SupplyChainPage.vue?vue&type=template&id=f2f63820&scoped=true&"
import script from "./SupplyChainPage.vue?vue&type=script&lang=js&"
export * from "./SupplyChainPage.vue?vue&type=script&lang=js&"
import style0 from "./SupplyChainPage.vue?vue&type=style&index=0&id=f2f63820&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f63820",
  null
  
)

export default component.exports